import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ColumnsType } from 'antd/lib/table';
import { Button, Table } from 'antd';
import cx from 'classnames';

import {
  SortingEnum,
  PreviewAgingReport,
  AgingSummarySortFieldEnum,
} from 'api/backofficeApiClient';
import { getPreviewAgingSummaryReport } from 'redux/reducers/homeDashboardSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from '../../UserHomePage.module.less';
import commonStyles from './AgingReportPreview.module.less';

const columns: ColumnsType<PreviewAgingReport> = [
  {
    title: 'Customer Name',
    key: 'customerCompanyName',
    render: ({ customerCompanyName }: PreviewAgingReport) =>
      customerCompanyName || '',
  },
  {
    title: 'Customer ID',
    key: 'customerKey',
    render: ({ customerKey }: PreviewAgingReport) => customerKey || '',
  },
  {
    title: 'Terms',
    key: 'terms',
    render: ({ terms }: PreviewAgingReport) => terms || '',
  },
  {
    title: 'Total Balance',
    key: 'totalBalance',
    render: (record: PreviewAgingReport) => record.totalBalance || '',
  },
];

export default function AgingReportPreview() {
  const [profitReportPreviewData, setProfitReportPreviewData] =
    useState<PreviewAgingReport[]>();
  const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const loadprofitReportPreviewData = useCallback(async () => {
    const result = await dispatch(
      getPreviewAgingSummaryReport({
        sortField: AgingSummarySortFieldEnum.Customer,
        sortType: SortingEnum.Asc,
        pageNumber: 0,
        pageSize: 5,
      }),
    );

    if (getPreviewAgingSummaryReport.fulfilled.match(result)) {
      setProfitReportPreviewData(result.payload);
    } else {
      setProfitReportPreviewData(undefined);
    }
  }, [dispatch]);

  const loadInitialData = useCallback(async () => {
    await loadprofitReportPreviewData();

    setIsInitialDataLoaded(true);
  }, [loadprofitReportPreviewData]);

  useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  return (
    <div className={styles.tableWrapper}>
      <div className={styles.title}>
        <Link to="/aging-report-summary-details">AR Aging - Summary</Link>

        <Button
          type="primary"
          onClick={() => navigate('/aging-report-summary-details')}
        >
          View Details
        </Button>
      </div>

      <Table
        className={cx(commonStyles.table, styles.table, 'custom-table')}
        columns={columns}
        pagination={false}
        loading={!isInitialDataLoaded}
        dataSource={profitReportPreviewData}
        rowKey={(record) => record?.customerKey as string}
        locale={{
          emptyText: 'You currently do not have any data in the report.',
        }}
      />
    </div>
  );
}
